<template>
  <div class="loading">
    <div class="dot-pulse"></div>
  </div>
</template>

<script>
import { Vue } from "vue-class-component";

export default class Loading extends Vue {}
</script>

<style lang="scss" scoped>


.loading {
  overflow: hidden;
  margin: 12px 0 12px 0;
  padding: 18px 36px;
  width: fit-content;
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%),
    0 1px 3px 0 rgb(0 0 0 / 12%);
  border-radius: 14px 14px 14px 0;
  background-color: $color3;
}

.dot-floating {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: $textColor;
  color: $textColor;
  animation: dotFloating 3s infinite cubic-bezier(0.15, 0.6, 0.9, 0.1);
}

.dot-floating::before,
.dot-floating::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-floating::before {
  left: -12px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: $textColor;
  color: $textColor;
  animation: dotFloatingBefore 3s infinite ease-in-out;
}

.dot-floating::after {
  left: -24px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: $textColor;
  color: $textColor;
  animation: dotFloatingAfter 3s infinite cubic-bezier(0.4, 0, 1, 1);
}

@keyframes dotFloating {
  0% {
    left: calc(-50% - 5px);
  }
  75% {
    left: calc(50% + 105px);
  }
  100% {
    left: calc(50% + 105px);
  }
}

@keyframes dotFloatingBefore {
  0% {
    left: -50px;
  }
  50% {
    left: -12px;
  }
  75% {
    left: -50px;
  }
  100% {
    left: -50px;
  }
}

@keyframes dotFloatingAfter {
  0% {
    left: -100px;
  }
  50% {
    left: -24px;
  }
  75% {
    left: -100px;
  }
  100% {
    left: -100px;
  }
}

/////////////////////--------------------------------------//////////////////////

.dot-pulse {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: $textColor;
  color: $textColor;
  box-shadow: 9999px 0 0 -5px $textColor;
  animation: dotPulse 1.5s infinite linear;
  animation-delay: 0.25s;
}

.dot-pulse::before,
.dot-pulse::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: $textColor;
  color: $textColor;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px $textColor;
  animation: dotPulseBefore 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px $textColor;
  animation: dotPulseAfter 1.5s infinite linear;
  animation-delay: 0.5s;
}

@keyframes dotPulseBefore {
  0% {
    box-shadow: 9984px 0 0 -5px $textColor;
  }
  30% {
    box-shadow: 9984px 0 0 2px $textColor;
  }
  60%,
  100% {
    box-shadow: 9984px 0 0 -5px $textColor;
  }
}

@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px $textColor;
  }
  30% {
    box-shadow: 9999px 0 0 2px $textColor;
  }
  60%,
  100% {
    box-shadow: 9999px 0 0 -5px $textColor;
  }
}

@keyframes dotPulseAfter {
  0% {
    box-shadow: 10014px 0 0 -5px $textColor;
  }
  30% {
    box-shadow: 10014px 0 0 2px $textColor;
  }
  60%,
  100% {
    box-shadow: 10014px 0 0 -5px $textColor;
  }
}
</style>